import { render, staticRenderFns } from "./DotBtn.vue?vue&type=template&id=45f54fce&scoped=true&"
import script from "./DotBtn.vue?vue&type=script&lang=js&"
export * from "./DotBtn.vue?vue&type=script&lang=js&"
import style0 from "./DotBtn.vue?vue&type=style&index=0&id=45f54fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f54fce",
  null
  
)

export default component.exports